import { useState } from "react";
import { useSelector } from "react-redux";
import { truncateDesc } from "../../../../../functions/truncateDesc";
import { getExpenseStatus } from "../../../../../functions/getExpenseStatus";
import { formatDate } from "../../../../../functions/dateTime/formatDate";
import ImageSlider from "../../../../UI/viewDialogs/ImageSlider";
import ExpenseHistoryView from "./ExpenseHistoryView";
import { changeExpenseAmountData } from "../../../../../functions/changeExpenseAmountData";

const ExpenseHistoryResultsContainer = () => {
  const data = useSelector((state) => state.data.data);
  const expenseData = changeExpenseAmountData(data.expenses);

  const [viewDialogDetails, setViewDialogDetails] = useState({});
  const [imageSliderPics, setImageSliderPics] = useState([]);
  const [imageSliderCurrentIndex, setImageSliderCurrentIndex] = useState();

  const closeViewDialog = () => {
    setViewDialogDetails({ ...viewDialogDetails, open: false });
  };

  const openImageSlider = (Pics) => {
    closeViewDialog();
    setImageSliderPics(Pics);
  };

  const closeImageSlider = () => {
    setImageSliderPics([]);
    setViewDialogDetails({ ...viewDialogDetails, open: true });
  };

  return (
    <>
      <h3 className="text-xl max-lg:text-lg font-figtreeMedium">
        Expense History Results ({expenseData.length})
      </h3>
      <div className="mt-4 max-md:mt-2 h-[calc(100vh-17em)] lg:h-[calc(100vh-20em)] overflow-y-scroll">
        <table className="w-full border-collapse text-center max-lg:text-sm">
          <thead className="sticky top-0">
            <tr className="bg-dBlue-100 uppercase tracking-wide rounded-full text-dark-blue">
              <th className="px-4 py-2  rounded-l-full">SN</th>
              <th className="px-4 py-2">Amount</th>
              <th className="px-4 py-2">Description</th>
              <th className="px-4 py-2">Category</th>
              <th className="px-4 py-2">Status</th>
              <th className="px-4 py-2">Date</th>
              <th className="px-4 py-2 rounded-r-full">Action</th>
            </tr>
          </thead>
          <tbody className="text-light-black">
            {expenseData.map((expense, ind) => (
              <>
                <tr key={ind} className="bg-white hover:bg-gray-50 border-b">
                  <td className="px-4 py-2">{ind + 1}.</td>
                  <td className="px-4 py-2">{`₹${expense.amount}`}</td>
                  <td className="px-4 py-2">
                    {truncateDesc(expense.description)}
                  </td>
                  <td className="px-4 py-2">{expense.category.name}</td>

                  <td
                    className={`px-4 py-2 ${
                      getExpenseStatus(expense.state).textColor
                    }`}
                  >
                    {getExpenseStatus(expense.state).status}
                  </td>
                  <td className="px-4 py-2">{formatDate(expense.date)}</td>
                  <td className="px-4 py-2">
                    <button
                      className="px-4 py-[3px] bg-dBlue-100 text-dark-blue rounded-full text-sm hover:bg-dark-blue hover:text-white transition"
                      onClick={() =>
                        setViewDialogDetails({ open: true, data: expense })
                      }
                    >
                      View
                    </button>
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
      {viewDialogDetails?.open && (
        <ExpenseHistoryView
          closeDialog={closeViewDialog}
          viewDetails={viewDialogDetails.data}
          openImageSlider={openImageSlider}
          setImageSliderCurrentIndex={setImageSliderCurrentIndex}
        />
      )}
      {imageSliderPics.length !== 0 && (
        <ImageSlider
          title="Expense Photos"
          images={imageSliderPics}
          imageSliderCurrentIndex={imageSliderCurrentIndex}
          closeDialogBox={closeImageSlider}
        />
      )}
    </>
  );
};

export default ExpenseHistoryResultsContainer;
